import React from "react"

import { GridColDef } from "@mui/x-data-grid"

import {
	Document,
	OrderType,
	PaginatedResponse, SearchFilter, SessionResponse,
} from "models"
import { SbPaginatedDatagrid } from "components/commons"

import getTaskTableColumns, { DocumentTableInterface } from "./documents-table-columns"

interface DocumentsTableProps
{
	data: PaginatedResponse<Document> | null
	downloadBaseUrl: string

	pagination: SearchFilter
	onPaginationChanged: (pageId: number, pageSize: number) => void
	onSortChanged: (orderBy: string|null, orderType: OrderType|null) => void

	deleteDocument?: (documentId: string) => void
	copyDocumentLink?: (documentId: string) => void
	onDownloadError: (error: any, originalResponse: Response) => void
	sessionData: SessionResponse
}
interface DocumentsTableState
{
}
export class DocumentsTable
	extends React.Component<DocumentsTableProps, DocumentsTableState>
	implements DocumentTableInterface
{
	private readonly columns: GridColDef[]

	constructor(props: DocumentsTableProps)
	{
		super(props)
		this.state = { }

		this.columns = getTaskTableColumns(this)
	}

	public deleteDocument(documentId: string): void
	{
		if(this.props.deleteDocument){
			this.props.deleteDocument(documentId)
		}
	}

	public onDownloadError = (error: any, originalResponse: Response): void => {
		this.props.onDownloadError(error, originalResponse)
	}

	public getDownloadBaseUrl = (): string => {
		return this.props.downloadBaseUrl
	}

	public sessionAccountType = (): string => {
		return this.props.sessionData.accountType
	}

	public copyDocumentLink = (documentId: string): void => {
		if (this.props.copyDocumentLink) {
			this.props.copyDocumentLink(documentId)
		}
	}

	render()
	{
		return (
			<SbPaginatedDatagrid
				columns={this.columns}
				data={this.props.data}
				pagination={this.props.pagination}
				onPaginationChanged={this.props.onPaginationChanged}
				onSortChanged={this.props.onSortChanged}
			/>
		)
	}
}
